import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Label } from '../ui/label';

export function InternalApprovalDialog({ approvalAction, handleInternalApproval, rejectionReason, selectedInternalRequest, setRejectionReason, setShowInternalApproval, showInternalApproval }) {
  return (
    <Dialog open={showInternalApproval} onOpenChange={setShowInternalApproval}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {approvalAction === 'approve' ? 'Setujui' : 'Tolak'} Internal Payment Request
          </DialogTitle>
          <p className="text-sm text-slate-600">Konfirmasi aksi Anda</p>
        </DialogHeader>
        {selectedInternalRequest && (
          <div className="space-y-4">
            <div className="bg-purple-50 p-4 rounded-lg">
              <p className="text-sm text-slate-600">Request Number</p>
              <p className="font-mono font-semibold">{selectedInternalRequest.request_number}</p>
              <p className="text-sm text-slate-600 mt-2">Tipe Request</p>
              <p className="font-semibold">{selectedInternalRequest.tipe_request}</p>
              <p className="text-sm text-slate-600 mt-2">Amount</p>
              <p className="font-mono font-semibold text-lg">Rp {selectedInternalRequest.amount?.toLocaleString('id-ID')}</p>
              <p className="text-sm text-slate-600 mt-2">Penerima</p>
              <p className="font-semibold">{selectedInternalRequest.penerima_nama}</p>
            </div>

            {approvalAction === 'reject' && (
              <div className="space-y-2">
                <Label htmlFor="internal-rejection-reason">Alasan Penolakan</Label>
                <textarea
                  id="internal-rejection-reason"
                  data-testid="internal-rejection-reason-input"
                  className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  required
                  placeholder="Masukkan alasan penolakan..."
                />
              </div>
            )}

            <Button
              onClick={() => handleInternalApproval(selectedInternalRequest.id)}
              className={`w-full ${approvalAction === 'approve' ? 'bg-emerald-600 hover:bg-emerald-700' : 'bg-rose-600 hover:bg-rose-700'}`}
              data-testid="confirm-internal-approval-button"
              disabled={approvalAction === 'reject' && !rejectionReason}
            >
              {approvalAction === 'approve' ? 'Konfirmasi Approval' : 'Konfirmasi Penolakan'}
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
